function shouldLogDiagnostics() {
  return process.env.NODE_ENV !== 'production';
}

export function warnDev(...args) {
  if (shouldLogDiagnostics()) {
    console.warn(...args);
  }
}

export function errorDev(...args) {
  if (shouldLogDiagnostics()) {
    console.error(...args);
  }
}
